document.addEventListener('DOMContentLoaded', function() {
    const tabButtons = document.querySelectorAll('.product__tab-heads button');
    
    tabButtons.forEach(button => {
        button.addEventListener('click', function() {
            tabButtons.forEach(btn => btn.classList.remove('active'));
            
            this.classList.add('active');
            
            document.querySelectorAll('.product__tabs .product-tab').forEach(tab => {
                tab.classList.remove('active');
            });
            
            document.querySelector('.product__tabs .product-tab[id="' + this.dataset.tab + '"]').classList.add('active');
        });
    });

  
});

 document.addEventListener("DOMContentLoaded", function () {
            
       const slider = document.querySelector('#getstyle .slider-mobile-gutter');
let mouseDown = false;
let startX, scrollLeft;

let startDragging = function (e) {
  mouseDown = true;
  startX = e.pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;
};
let stopDragging = function (event) {
  mouseDown = false;
};

   if(slider){
     slider.addEventListener('mousemove', (e) => {
  e.preventDefault();
  if(!mouseDown) { return; }
  const x = e.pageX - slider.offsetLeft;
  const scroll = x - startX;
  slider.scrollLeft = scrollLeft - scroll;
});

// Add the event listeners
slider.addEventListener('mousedown', startDragging, false);
slider.addEventListener('mouseup', stopDragging, false);
slider.addEventListener('mouseleave', stopDragging, false);

   }

        });